module.exports = __webpack_public_path__ + "img/36.703668c1.jpg";